// extracted by mini-css-extract-plugin
module.exports = {"game_box":"game_box-3_yMT4uc"};